import {useCallback, useRef} from 'react';
import {useAppSelector} from "./redux";
import {DATE_FORMAT} from "../constants";
import {LANG} from "../types/IUser";

export function useDateFormat() {
    const { lang } = useAppSelector(state => state.auth);

    return DATE_FORMAT[lang] || DATE_FORMAT[LANG.RU]
};